import React from "react";
import { Box, CircularProgress } from "@mui/material";

/** Centered loader for fee module list / page states */
const FeePageLoader = ({ minHeight = 280, size = 40 }) => (
  <Box
    display="flex"
    justifyContent="center"
    alignItems="center"
    width="100%"
    minHeight={minHeight}
    py={4}
  >
    <CircularProgress size={size} />
  </Box>
);

export default FeePageLoader;
